import {
    BrochureCard,
    FetchBrochuresPublicationsListPayload,
    FetchBrochuresPublicationsListResponse,
} from './brochuresPublicationsList.types';
import formatDateString from '../../../helpers/formatDate';
import { updatePaginationButtons } from '../pagination/pagination';
import copyToClipboard from '../../../helpers/copyToClipboard';
import axios from 'axios';

const borchuresPublicationsList: HTMLDivElement = document.querySelector('.brochures-list');

if (borchuresPublicationsList) {
    const brochuresGrid = borchuresPublicationsList.querySelector('.brochures-list__grid') as HTMLDivElement;
    const identityFilters = borchuresPublicationsList.querySelector('.brochures-list__search') as HTMLDivElement;
    const borchuresPublicationsListSearchInput = borchuresPublicationsList.querySelector(
        '.brochures-list__search-input'
    ) as HTMLInputElement;
    const nextPageButton = borchuresPublicationsList.querySelector('.pagination__page-next') as HTMLButtonElement;
    const prevPageButton = borchuresPublicationsList.querySelector('.pagination__page-prev') as HTMLButtonElement;
    const paginationDropdown = borchuresPublicationsList.querySelector('.pagination__dropdown') as HTMLSelectElement;
    const paginationLast = borchuresPublicationsList.querySelector('.pagination__page-last') as HTMLSelectElement;
    const paginationFirst = borchuresPublicationsList.querySelector('.pagination__page-first') as HTMLSelectElement;
    const pagination = borchuresPublicationsList.querySelector('.pagination') as HTMLDivElement;
    const radios: NodeListOf<HTMLInputElement> = borchuresPublicationsList.querySelectorAll('.sort-filter__input');
    const currentCulture: string = document.documentElement.getAttribute('culture');

    let brochureCards: BrochureCard[] = [];
    let keyword: string = '';
    let sortBy: number = 1;
    let pageNumber: number = 1;
    let pageSize: number = +paginationDropdown?.value;
    let totalPages: number = 0;
    let totalCount: number = 0;
    let hasNextPage: boolean = false;
    let hasPreviousPage: boolean = false;
    let buttonsToShow: number = 3;
    let isLoading: boolean = false;
    let clickedNumber = null;

    const fetchBrochuresPublications = async (page = null) => {
        clickedNumber = page;
        pagination?.classList.add('hidden');

        if (clickedNumber) {
            pageNumber = page;
        }

        const payload: FetchBrochuresPublicationsListPayload = {
            keyword,
            sortBy,
            pageNumber,
            pageSize,
            currentCulture,
        };

        isLoading = true;

        disableInputs();

        try {
            let response;
            if (
                (window.location.hostname === 'localhost' && window.location.port === '2000') ||
                window.location.hostname === 'mawhiba-fractal.netlify.app'
            ) {
                response = await axios.post<FetchBrochuresPublicationsListResponse>(
                    'https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/brochurespublications',
                    payload
                );
            } else {
                response = await axios.post<FetchBrochuresPublicationsListResponse>(
                    '/api/brochurespublications',
                    payload
                );
            }
            brochureCards = response.data.items;
            if (brochureCards.length > 0) {
                pagination.classList.remove('hidden');
            }
            totalPages = response.data.totalPages;
            totalCount = response.data.totalCount;
            hasNextPage = response.data.hasNextPage;
            hasPreviousPage = response.data.hasPreviousPage;
        } catch (error) {
            console.error(error);
            enableInputs();
        } finally {
            updatePaginationButtons(
                totalPages,
                hasPreviousPage,
                hasNextPage,
                pageNumber,
                pageSize,
                totalCount,
                buttonsToShow,
                brochureCards,
                fetchBrochuresPublications
            );
            isLoading = false;
            updateCards();
            enableInputs();
        }
    };

    const updateCards = () => {
        brochuresGrid.innerHTML = '';

        brochureCards.forEach((card: BrochureCard) => {
            const cardElement = document.createElement('div');
            cardElement.className = 'science-card flex flex--column flex--align-start flex--justify-between';

            cardElement.innerHTML = `
                    <div class="science-card__top flex flex--wrap">
                        <div class="science-card__image-container flex flex--align-center flex--justify-center">
                            <img src=${card.image} alt="image" class="science-card__image">
                        </div>
                        <div class="science-card__content flex flex--column flex--justify-start">
                            <div class='science-card__date flex flex--align-center'>
                                <div class="science-card__date-inner flex flex--align-center">
                                    <img src='/assets/img/img/calendar-icon-yellow.svg' alt='calendar icon' class='science-card__date-icon' />
                                    <span class='science-card__date-text'>
                                    ${formatDateString(card.date)}
                                    </span>
                                </div>
                                <img src="/assets/img/fractal/filetype--${card.fileType}.svg"
                                 alt="pdf icon" class="science-card__pdf">
                            </div>
                            <span class="science-card__title">${card.title}</span>
                            <span class="science-card__text">${card.description}</span>
                        </div>
                    </div>
                    <div class="science-card__bottom flex flex--wrap flex--align-center">
                        <a href="${card.link}"
                         draggable="false" class="link link--secondary science-card__link science-card__link--full flex flex--justify-center flex--align-center" target="_blank">
                            <span class="link__label">${card.linkTitle}</span>
                            <img class="link__image" src="/assets/img/img/arrow-top-left-dark.svg" alt="/assets/img/img/arrow-top-left-dark.svg">
                        </a>
                        <div class="science-card__buttons flex flex--align-center">
                            <button class="button button--round-tiny shareButton brochures-list__item__button brochures-list__item__button-share flex flex--justify-center flex--align-center">
                                <img src="/assets/img/img/share-icon.svg" alt="share icon" class="button__image">
                            </button>
                            <a href="${card.link}"
                                 draggable="false" class="link link--round-tiny science-card__button science-card__button-download flex flex--justify-center flex--align-center" download="${card.link}" target="_blank">
                                <img class="link__image" src="/assets/img/img/download-icon-dark.svg" alt="/assets/img/img/download-icon-dark.svg">
                            </a>
                        </div>
                    </div>
            `;

            brochuresGrid.appendChild(cardElement);
        });

        addCardListeners();
    };

    const disableInputs = () => {
        pagination?.classList.add('disabled');
        identityFilters?.classList.add('disabled');
    };

    const enableInputs = () => {
        pagination?.classList.remove('disabled');
        identityFilters.classList.remove('disabled');
    };

    paginationDropdown?.addEventListener('change', () => {
        pageSize = +paginationDropdown.value;
        pageNumber = 1;
        fetchBrochuresPublications();
    });

    nextPageButton?.addEventListener('click', () => {
        pageNumber++;

        fetchBrochuresPublications();
    });

    prevPageButton?.addEventListener('click', () => {
        pageNumber--;

        fetchBrochuresPublications();
    });

    paginationFirst?.addEventListener('click', () => {
        pageNumber = 1;
        fetchBrochuresPublications();
    });

    paginationLast?.addEventListener('click', () => {
        pageNumber = totalPages;
        fetchBrochuresPublications();
    });

    let timeout = null;
    borchuresPublicationsListSearchInput?.addEventListener('input', (e) => {
        clearTimeout(timeout);

        timeout = setTimeout(function () {
            keyword = borchuresPublicationsListSearchInput.value.trim();
            pageNumber = 1;
            fetchBrochuresPublications();
        }, 1000);
    });

    radios.forEach((radio) => {
        // 1 = A-Z
        // 2 = Z-A

        radio.addEventListener('change', () => {
            const checkedRadio = borchuresPublicationsList.querySelector(
                'input[name="sort-filter"]:checked'
            ) as HTMLInputElement;
            const checkedRadioValue = checkedRadio.value;
            sortBy = +checkedRadioValue;
            fetchBrochuresPublications();
        });
    });

    fetchBrochuresPublications();

    const addCardListeners = () => {
        const brochuresListCards: NodeListOf<HTMLAnchorElement> =
            brochuresGrid.querySelectorAll('.brochures-list__item');

        if (brochuresListCards.length > 0) {
            const cardButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll(
                '.brochures-list__item__button',
            );

            cardButtons.forEach((button) => {
                button.addEventListener('click', (e) => {
                    if (button.classList.contains('shareButton')) {
                        copyToClipboard(button);
                    }
                });
            });
        }
    };

    const shareButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                copyToClipboard(button);
            });
        });
    }
}
